/* eslint-disable func-style */
import React, { createContext, useReducer, useContext } from 'react';

export const MonitoringContext = createContext();

export const actions = {
  MONITOR_NODES: 'MONITOR_NODE',
  EXPIRE_MONITORING: 'EXPIRE_MONITORING',
  ON_MONITOR_ERROR: 'ON_MONITOR_ERROR',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.MONITOR_NODES: {
      const { expires_at: expiresAt, warning, message } = action.payload;

      return {
        ...state,
        isMonitoring: !!expiresAt,
        expiresAt,
        message: warning && { content: message, warning: true },
      };
    }
    case actions.EXPIRE_MONITORING: {
      return { ...state, isExpired: true };
    }
    case actions.ON_MONITOR_ERROR: {
      const { error, message } = action.payload;

      return {
        ...state,
        message: error && {
          content: message,
          error: true,
          title: 'Failed to Start Monitoring',
        },
      };
    }
    case actions.CLEAR_MESSAGE: {
      return { ...state, message: null };
    }
    default:
      throw new Error();
  }
};

export const useMonitoringContext = () => {
  const context = useContext(MonitoringContext);

  return context;
};

export function MonitoringContextController({ children, ...initialState }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MonitoringContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </MonitoringContext.Provider>
  );
}
